var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100 fill" },
    [
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            { staticClass: "fill justify-between" },
            [
              _c(
                "b-col",
                {
                  staticClass: "pt-4 fill overflow-y-scroll shadow bg-white",
                  attrs: { cols: "4" }
                },
                [
                  _c(
                    "transition",
                    {
                      attrs: {
                        "enter-active-class": "animated fadeIn",
                        "leave-active-class": "animated fadeOut"
                      }
                    },
                    _vm._l(_vm.getRepositories, function(repository) {
                      return _c("rs-repository-tree", {
                        key: repository.repositorioId,
                        staticClass: "item",
                        attrs: { repository: repository }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "b-col",
                { staticClass: "h-100 flex flex-col", attrs: { md: "8" } },
                [
                  _c(
                    "div",
                    { staticClass: "nav-panel" },
                    [
                      _c("rs-navigation-panel", {
                        attrs: {
                          "add-file": _vm.addFile,
                          toggle: _vm.toggle,
                          files: _vm.files,
                          "show-principal-button": _vm.showPrincipalButton,
                          "max-files": _vm.maxFiles,
                          "required-file-type": _vm.requiredFileType,
                          "accepted-file-extensions":
                            _vm.acceptedFileExtensions,
                          "required-approval-state": _vm.requiredApprovalState
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "selected-docs-panel" },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { cols: "12" } }, [
                            _c("h4", { staticClass: "text-primary m-0 p-2" }, [
                              _vm._v(
                                " Documentos seleccionados " +
                                  _vm._s(
                                    _vm.files.length + "/" + _vm.maxFiles
                                  ) +
                                  " "
                              )
                            ])
                          ]),
                          _vm._l(_vm.files, function(file) {
                            return _c(
                              "b-col",
                              {
                                key: file.id,
                                staticClass: "text-center mb-3",
                                attrs: { cols: "3" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-column align-items-center"
                                  },
                                  [
                                    _c("vs-icon", {
                                      attrs: {
                                        icon: "description",
                                        size: "25px",
                                        color: "primary"
                                      }
                                    }),
                                    _c(
                                      "b",
                                      {
                                        staticClass: "text-truncate w-100 mt-2"
                                      },
                                      [_vm._v(_vm._s(file.name))]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }